import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import './StoriesProgressBar.less';

const StoriesProgressBar = ({ stories, currentIndex, isPaused, setProgressBarRefs, assetIsReady }) => (
  <div className="zostories__progress-container">
    {stories.map((story, i) => {
      const { duration = 10000 } = story;
      return (
        <div className={cx('zostories__progress-bar', { 'zostories__progress-bar--isCurrent': assetIsReady && i === currentIndex })} key={i}>
          <span
            ref={ref => setProgressBarRefs(ref, i)}
            style={{ animationDuration: `${duration}ms` }}
            className={cx(
              'zostories__progress-animation',
              { 'zostories__progress-animation--viewed': i < currentIndex },
              { 'zostories__progress-animation--isPaused': i === currentIndex && isPaused }
            )}
          />
        </div>
      );
    })}
  </div>
);

StoriesProgressBar.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object).isRequired,
  setProgressBarRefs: PropTypes.func.isRequired,
  currentIndex: PropTypes.number,
  isPaused: PropTypes.bool,
  assetIsReady: PropTypes.bool,
};

export default StoriesProgressBar;



// WEBPACK FOOTER //
// ./src/components/onboard/Stories/StoriesProgressBar/StoriesProgressBar.jsx